import Cookies from 'js-cookie';
import { matchRoutes } from 'react-router-dom';

import { userHasAccessToVenue } from './active-venue';
import { getAppOrigin } from './session-auth-http';

let redirectingToLogin = false;

export function persistNextUrlForLogin(location = typeof window !== 'undefined' ? window.location : null) {
  if (!location) return;

  const { pathname, search, hash } = location;
  if (!pathname || pathname.startsWith('/login') || pathname === '/logout') return;

  Cookies.set('next', `${pathname}${search || ''}${hash || ''}`, { path: '/' });
}

function getPathname(url) {
  try {
    return new URL(url, getAppOrigin()).pathname;
  } catch {
    return null;
  }
}

function getVenueIdFromPath(routes, pathname) {
  const matches = matchRoutes(routes, pathname) || [];
  const venueMatch = matches.find(({ params }) => params.venueId);
  return venueMatch ? venueMatch.params.venueId : null;
}

export function consumeNextUrlForLogin(user, routes = []) {
  const next = Cookies.get('next');
  if (!next) return null;
  Cookies.remove('next', { path: '/' });

  const pathname = getPathname(next);
  if (!pathname) return null;

  const venueId = getVenueIdFromPath(routes, pathname);
  if (venueId && !userHasAccessToVenue(user, venueId)) return null;

  return next;
}

// Synchronous read of the in-flight flag. ComponentErrorBoundary consults this in render
// because redux `connect` subscriptions don't propagate within the same tick that
// `getDerivedStateFromError` runs — a render-time throw caused by the same auth failure
// would otherwise flash the maintenance overlay before props update.
export function isRedirectingToLogin() {
  return redirectingToLogin;
}

export function redirectToLoginOnce(status) {
  if (redirectingToLogin) return;
  if (typeof window === 'undefined' || !window.store) return;

  redirectingToLogin = true;
  // Action type kept inline to avoid a circular import with features/App/App.saga.
  window.store.dispatch({ type: 'SESSION_AUTH_EXPIRED', status });
}

/** @internal test helper */
export function resetRedirectToLoginStateForTests() {
  redirectingToLogin = false;
}
